module.exports = __webpack_public_path__ + "static/media/connect-wallet-slide-2.205bd12c.svg";